import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
  styled
} from "@mui/material";
import { ModalDialogTransition } from "@qubit/autoparts";
import { ReactNode } from "react";

const DialogText = styled(DialogContentText)(({ theme }) => ({
  textAlign: "center",
  fontSize: "20px",
  fontWeight: 400,
  lineHeight: 1.5,
  whiteSpace: "pre-line",
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(1)
}));

export type RecoveryActionModalAction = {
  label: string;
  onClick: () => void;
};

export type RecoveryActionModalProps = {
  isOpen: boolean;
  title: string;
  message: ReactNode;
  primaryAction: RecoveryActionModalAction;
  secondaryAction: RecoveryActionModalAction;
  labelledById: string;
} & Pick<DialogProps, "disableEscapeKeyDown">;

export function RecoveryActionModal({
  isOpen,
  title,
  message,
  primaryAction,
  secondaryAction,
  labelledById,
  disableEscapeKeyDown = true
}: RecoveryActionModalProps): React.ReactElement {
  return (
    <Dialog
      open={isOpen}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown={disableEscapeKeyDown}
      slots={{ transition: ModalDialogTransition }}
      aria-labelledby={labelledById}
      aria-describedby="recovery-action-modal-description"
      slotProps={{ paper: { sx: { borderRadius: 3 } } }}
    >
      <DialogTitle
        id={labelledById}
        sx={{ textAlign: "center", pb: 0, pt: 3, px: 3 }}
      >
        {title}
      </DialogTitle>
      <DialogContent sx={{ pt: 0, px: { xs: 3, sm: 5 }, pb: 2 }}>
        <DialogText id="recovery-action-modal-description">
          {message}
        </DialogText>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
          gap: 2,
          px: 3,
          pb: 3,
          pt: 1,
          flexWrap: "wrap"
        }}
      >
        <Button
          size="large"
          variant="contained"
          onClick={primaryAction.onClick}
        >
          {primaryAction.label}
        </Button>
        <Button size="large" variant="text" onClick={secondaryAction.onClick}>
          {secondaryAction.label}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
